import { DataStub } from '@tencent/data-schema-core';
import { joinPath } from '@tencent/data-schema-core/lib/utils/path';
import { getBaseLayout } from "../../../../lib/designer/utils/layout";
import { arrayify } from "../../../../lib/utils/array";
export function createNewColumn() {
  return {
    id: Date.now().toString(36),
    title: '未命名列',
    description: '',
    width: '300px'
  };
}
export function wrapAsCellScopedSlot(children, uc) {
  return {
    layout: getBaseLayout(uc, 'scopedSlotRoot', arrayify(children))
  };
}
export default function getDefaultColumns({
  uc,
  dataStub
}) {
  var _dataStub$getChildStu;
  const cols = [];
  const scopedSlots = {};
  const fakeItemStub = new DataStub({
    schema: {
      type: 'object',
      fields: [{
        id: 'data',
        type: 'object',
        fields: [{
          ...dataStub.arrItems,
          id: 'item'
        }]
      }]
    },
    value: {
      data: {
        item: (_dataStub$getChildStu = dataStub.getChildStub(0)) === null || _dataStub$getChildStu === void 0 ? void 0 : _dataStub$getChildStu.value
      }
    }
  }).getStubAtPath('data.item');
  // 这个版本会引入 autoEditor
  const getStubEditor = path => ({
    layout: {
      type: 'w-form-auto-editor',
      bindings: {
        数据源: path ? joinPath(['data', 'item', path]) : 'data.item'
      }
    }
  });
  // eslint-disable-next-line max-len
  // const getStubEditor = (path: string) => uc.fitData(fakeItemStub.getStubAtPath(path)!).find(x => x.type === 'editor' && x.layout.type !== 'w-form-item');
  if (fakeItemStub.type === 'object') {
    // 这是个 object[]
    fakeItemStub.definedFields.slice(0, 15).forEach(field => {
      const {
        id
      } = field;
      if (!id) return;
      const editor = getStubEditor(id);
      if (!editor) return;
      const colId = `_${id}`;
      const title = field.title || id;
      const width = field.type === 'object' || field.type === 'array' ? '450px' : '200px';
      cols.push({
        id: colId,
        title,
        description: '',
        width
      });
      scopedSlots[`col-${colId}`] = wrapAsCellScopedSlot(editor.layout, uc);
    });
  } else {
    // 走默认方案吧
    const editor = getStubEditor('');
    if (!editor) return;
    cols.push({
      id: 'content',
      title: '数据',
      description: '',
      width: '300px'
    });
    scopedSlots['col-content'] = wrapAsCellScopedSlot(editor.layout, uc);
  }
  return {
    cols,
    scopedSlots
  };
}